import RoomForRentByFieldSet from './RoomForRentByFieldSet';
import MapPinAdjustmentAlert from '../../../MapPinAdjustmentAlert';
import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

const FormSectionContainer = () => {
  return (
    <WizardFormSectionContainer data-testid="FormSectionContainer">
      <MapPinAdjustmentAlert />
      <WizardHeading level={1} textStyle="heading-sm">
        Who&#39;s listing the room for rent?
      </WizardHeading>
      <WizardBody>
        <RoomForRentByFieldSet />
      </WizardBody>
    </WizardFormSectionContainer>
  );
};

export default FormSectionContainer;
